import React, { PropTypes } from 'react';
import { Navbar } from 'react-bootstrap';
import { IndexLink, Link } from 'react-router';

class Expense extends React.Component {
   render() {
      return (
         <div className="Expense" >
            <Navbar>
               <Navbar.Header>
                  <Navbar.Brand>
                     <Link to="/expense/" activeStyle={{ color: 'red' }} >Expense</Link>
                  </Navbar.Brand>
               </Navbar.Header>
               <ul className="nav navbar-nav" >
                  <li>
                     <IndexLink to="/expense/" activeStyle={{ color: 'red' }} >All</IndexLink>
                  </li>
                  <li>
                     <Link to="/expense/new" activeStyle={{ color: 'red' }} >New</Link>
                  </li>
                  <li>
                     <Link to="/expense/dueBills" activeStyle={{ color: 'red' }} >Due Bills</Link>
                  </li>
               </ul>
            </Navbar>
            {this.props.children}
         </div>
      );
   }
}

Expense.propTypes = {
   children: PropTypes.object
};

export default Expense;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Expense/Expense.js
 **/